(function () {

    'use strict';

    angular.module('FotocApp')

    .filter("useProxy", ['$editorService', function ($editorService){
        return function ($url, $crop, $rezise){
            return $editorService.getProxyImageUrl($url, $crop, $rezise);  
        }
    }])

    .directive('whenScrolled', function() {
        return function(scope, elm, attr) {
            var raw = elm[0];
            elm.bind('scroll', function() {
                if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight-100) {
                    scope.$apply(attr.whenScrolled);
                }
            });
        };
    })

})(); 